import { call } from '@/utils/yambda';
import React from 'react';

import Button from '../ImageButton/PageTitleImageButton';
import { IPageTitleProps, TPageTitleRightProps } from '../PageTitle';
import styles from './PageTitleRightButton.module.scss';
import clsx from 'clsx';

interface IPageTitleRightButtonProps {
  color: IPageTitleProps['color'];
  right: IPageTitleProps['right'];
  onBeforeClickRight: IPageTitleProps['onBeforeClickRight'];
  renderRight: IPageTitleProps['renderRight'];
  cartCount?: number;
}

/**
 * PageTitle 컴포넌트에서 right에 해당하는 부분
 */
const searchDefault = (): void => {
  window.location.href = '/search';
};
const homeDefault = (): void => {
  window.location.href = '/';
};

const PageTitleRightButton: React.FC<IPageTitleRightButtonProps> = ({
  color,
  right,
  onBeforeClickRight,
  renderRight,
  cartCount,
}) => {
  if (!right && !renderRight) {
    return null;
  }

  if (renderRight) {
    return renderRight();
  }

  const clickSearch = (typeof right !== 'string' && right?.search) || searchDefault;
  const searchButton = (
    <Button key="search" type="icon_search" onClick={clickSearch} onBeforeClick={onBeforeClickRight?.search} />
  );

  const clickHome = (typeof right !== 'string' && right?.home) || homeDefault;
  const homeButton = (
    <Button key="home" type="icon_home" onClick={clickHome} onBeforeClick={onBeforeClickRight?.home} />
  );

  /* search, home이 아닌 경우는 무조건 string이 아닌 객체로 들어온다. */
  const closeButton =
    typeof right !== 'string' ? (
      <Button key="close" type="icon_close" onClick={right?.close} onBeforeClick={onBeforeClickRight?.close} />
    ) : null;

  const shareButton =
    typeof right !== 'string' ? (
      <Button key="share" type="icon_share" onClick={right?.share} onBeforeClick={onBeforeClickRight?.share} />
    ) : null;

  const cartButton =
    typeof right !== 'string' ? (
      <Button key="cart" type="icon_cart" onClick={right?.cart} onBeforeClick={onBeforeClickRight?.cart}>
        {cartCount !== undefined && cartCount > 0 && <div className={styles.cartCount}>{cartCount}</div>}
      </Button>
    ) : null;

  const defaultButton = (
    <>
      {searchButton}
      {homeButton}
    </>
  );

  const renderButton = (type?: 'default' | TPageTitleRightProps): JSX.Element | null => {
    switch (type) {
      case 'default':
        return defaultButton;
      case 'search':
        return searchButton;
      case 'home':
        return homeButton;
      case 'close':
        return closeButton;
      case 'share':
        return shareButton;
      case 'cart':
        return cartButton;
      default:
        return null;
    }
  };

  const rightButton = call(() => {
    if (typeof right === 'string') {
      return renderButton(right);
    }

    return right && Object.keys(right).map((key: TPageTitleRightProps) => renderButton(key));
  });

  return <div className={clsx(styles.container, color === 'white' && styles.white)}>{rightButton}</div>;
};

export default PageTitleRightButton;
